module.exports = __webpack_public_path__ + "img/环保便利.70fbc394.png";